module.exports = function xor (a, b) {
  var len = a.length
  var i = -1
  while (++i < len) {
    a[i] ^= b[i]
  }
  return a
}



//////////////////
// WEBPACK FOOTER
// ./~/public-encrypt/xor.js
// module id = 680
// module chunks = 1